import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getTagsData } from 'models/tagsdata'; // Importing function to get tags data

/**
 * TagsView class extending JetView to create a specific view for tags.
 */
export default class TagsView extends JetView {
    /**
     * Configures the layout of the TagsView.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Awarded Badges'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view
                    type: 'barH', // Horizontal bar chart type
                    localId: 'chart', // Local identifier for the chart
                    radius: 0, // No border radius for bars
                    barWidth: 20, // Width of the bars
                    value: '#number#', // Data field for bar value
                    border: false, // No border around bars
                    padding: {
                        // Padding configuration
                        top: 0,
                        left: 20,
                        bottom: 40,
                    },
                    xAxis: {
                        // Configuration for the X-axis
                        start: 0, // Starting point
                        end: 32, // Ending point
                        step: 4, // Step size
                        color: '#fff', // Color of the axis
                        lineColor: '#EDEFF0', // Color of the axis line
                    },
                    yAxis: {
                        // Configuration for the Y-axis
                        template: '', // Template for Y-axis labels
                        lines: false, // No lines on the Y-axis
                        color: '#EDEFF0', // Color of the Y-axis
                    },
                    color: '#color#', // Data field for bar color
                    legend: {
                        // Configuration for the legend
                        template: (obj) => _(obj.tag), // Localized legend template
                        valign: 'middle', // Vertical alignment
                        align: 'right', // Horizontal alignment
                        width: 130, // Width of the legend
                        marker: {
                            // Marker configuration for legend
                            type: 'round', // Round marker type
                            width: 7, // Width of the marker
                            height: 8, // Height of the marker
                        },
                    },
                    tooltip: {
                        // Tooltip configuration
                        template: '#number# clients', // Template for tooltip content
                    },
                },
            ],
        };
    }

    /**
     * Initializes the TagsView.
     */
    init() {}
}

// FILE DOCUMENTED
